import { SCAttributes } from "../../generic/generic-sc-attributes";
import { SCKpis } from "../../generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../generic/generic-types";
import {
  ISalesCreditRetentionEquivType,
  IsalesCreditRetentionType,
} from "./AirPnlTypes";

export function mapData(dataSC: IGenericAggregateResponse): any | undefined {
  if (dataSC.aggregates && dataSC.aggregates.length === 0) {
    return undefined;
  }
  const totalSC = calculateTotalSC(dataSC);
  return calculateDataForSC(dataSC, totalSC);
}

function calculateTotalSC(dataSC: IGenericAggregateResponse) {
  let totalSC = 0;
  for (const row of dataSC.aggregates ? dataSC.aggregates : []) {
    totalSC += row.indicatorKpiValues[SCKpis.SC_YTD];
  }
  return totalSC / 1000;
}

function calculateDataForSC(
  dataSC: IGenericAggregateResponse,
  totalSC: number
): ISalesCreditRetentionEquivType {
  const retRate = "retention_rate";
  const scData: IsalesCreditRetentionType[] = [];
  const scEquiv: ISalesCreditRetentionEquivType = {
    BVEquiv: 0,
    RetentionEquiv: "",
    SalesCreditList: [],
  };
  for (const row of dataSC.aggregates ? dataSC.aggregates : []) {
    const ytdKeuro = row.indicatorKpiValues[SCKpis.SC_YTD] / 1000;
    scData.push({
      fpvtradenegoentityregion:
        row.dimensionAttributeValues[
          SCAttributes.SC_FPV_TRADE_NEGO_ENTITY_REGION
        ],
      pclabel: row.dimensionAttributeValues[SCAttributes.SC_FPV_TRADE_LABEL],
      pcmnemo: row.dimensionAttributeValues[SCAttributes.SC_FPV_TRADE_PC],
      percentage: totalSC !== 0 ? Number((ytdKeuro / totalSC) * 100) : 0,
      retentionRateGrossValue: row.indicatorKpiValues[retRate],
      retentionrate: Math.floor(row.indicatorKpiValues[retRate]),

      y: ytdKeuro,
    });
  }

  const bvEquiv = GetBVEquivData(scData);
  scEquiv.BVEquiv = Number(bvEquiv.toFixed(0));
  scEquiv.RetentionEquiv = `${(totalSC !== 0
    ? (bvEquiv / totalSC) * 100
    : 0
  ).toFixed(0)}%`;
  scEquiv.SalesCreditList = scData;
  return scEquiv;
}

function GetBVEquivData(scData: IsalesCreditRetentionType[]): number {
  let sum = 0;
  scData.forEach(element => {
    sum += element.y * Number(element.retentionRateGrossValue / 100);
  });
  return sum;
}
